function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.25183 3.36164C9.36277 3.49385 9.34553 3.69096 9.21332 3.8019L6.14419 6.37719C5.77244 6.68913 5.23038 6.68914 4.85862 6.3772L1.78953 3.80193C1.65732 3.691 1.64008 3.49389 1.75102 3.36167C1.86195 3.22946 2.05906 3.21222 2.19128 3.32316L5.37285 5.99281C5.4472 6.05519 5.55561 6.05519 5.62996 5.99281L8.81157 3.32312C8.94378 3.21218 9.14089 3.22943 9.25183 3.36164Z",
  fill: "currentColor",
  fillOpacity: 0.4
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/arrowDown.61ce87d6.svg";
export { SvgComponent as ReactComponent };